<template lang="">
  <div class="mon_list_in">
    <!-- 公共位置 -->
    <PositionGuid :posGuids="posGuids"></PositionGuid>
    <!-- 公共位置结束 -->
    <div class=" gWidth  padding bg-white" v-cloak>
      <div class=" padding-bottom">
        <!-- <span class="right_tit" >列表</span> -->
        <span class="mon_tit">{{ lanmu }}</span>
        <!-- <span class="right_tit bg-blue text-white flex flex-center align-center">专题专栏</span> -->
        <!-- <div class="diliver bg-blue"></div> -->
        <!-- mon_bor -->
        <div class="mon_bor2">
          <Lists
            :liebiaos="liebiaos"
            :totlePage="totlePage"
            @liebiao2="liebiao2"
          ></Lists>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { gg_list } from "@/api/gxq";
import Lists from "../../components/Lists/Lists";
import PositionGuid from "../../components/PositionGuid/PositionGuid";
export default {
  name: "MonListIn",
  components: {
    Lists,
    PositionGuid,
  },
  data() {
    return {
      posGuids: [
        {
          title: "",
          link: "",
        },
      ],
      currentPage: 1,
      totlePage: 45,
      liebiaos: [],
      // id: 96,
      id: this.$route.params.id,
      isLoading: false,
      lanmu: "",
    };
  },
  mounted() {
    this.liebiao2();
  },
  methods: {
    async liebiao2(page) {
      const { data } = await gg_list({
        id: this.id,
        page: page ? page - 1 : 0,
      });
      this.liebiaos = data.data;
      this.lanmu = data.lanmu;
      this.$set(this.posGuids[0], "title", data.lanmu);
      // console.log(this.liebiaos);
      this.totlePage = data.pages;
    },
  },
};
</script>
<style src="../../../vab/styles/gaikuang/gaikuang_big.css" scoped></style>
<style src="../../../vab/styles/gaikuang/gaikuang_mid.css" scoped></style>
<style src="../../../vab/styles/gaikuang/gaikuang_small.css" scoped></style>
<style src="../../../vab/styles/mon_list.css" scoped></style>
<style scoped>
.news_r_b {
  padding-top: 0 !important;
}
</style>
